  /* ── Rolling digit on quantity steppers ────────────────────────────────────
     Display only. The real <input> stays the source of truth and stays
     focusable and typable — global.js and <quantity-input> are untouched. A
     transparent-text input sits under an overlay that carries the visible
     number; pressing + or − rolls that number in the direction of travel
     (increase rises from below). The moment the field takes focus the overlay
     steps aside and the real input shows itself, so typed entry never
     animates. Moved here from assets/ss-page-controls.js on 2026-09-27 when
     that file was retired: the custom hero is the one live caller
     (attachHeroQtyRoll below); scan() still serves a Dawn <quantity-input>
     if one is ever rendered on a product.json page.                         */
  (function () {
    if (window.SSQtyRoll) return;

    var DUR = 170; // ms — matches the CSS animations in custom.css

    function reduceMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function attach(input) {
      if (!input || input.dataset.ssQtyRoll) return;
      var host = input.parentElement;
      if (!host) return;
      input.dataset.ssQtyRoll = '1';
      host.classList.add('ss-qty-roll-host');
      input.classList.add('ss-qty-roll-input');

      /* Copy the field's own type down onto the overlay so the two are
         indistinguishable on either surface. */
      var cs = window.getComputedStyle(input);
      var roll = document.createElement('span');
      roll.className = 'ss-qty-roll';
      roll.setAttribute('aria-hidden', 'true');
      roll.style.fontFamily = cs.fontFamily;
      roll.style.fontSize = cs.fontSize;
      roll.style.fontWeight = cs.fontWeight;
      roll.style.letterSpacing = cs.letterSpacing;
      roll.style.color = cs.color;
      input.style.setProperty('--ss-qty-color', cs.color);

      var val = document.createElement('span');
      val.className = 'ss-qty-roll__val';
      val.textContent = input.value;
      roll.appendChild(val);
      host.appendChild(roll);

      var last = input.value;
      var typing = false;

      function sync(animate) {
        var next = input.value;
        if (next === last) return;
        var rising = (parseFloat(next) || 0) >= (parseFloat(last) || 0);
        last = next;
        if (!animate || typing || reduceMotion()) {
          val.textContent = next;
          return;
        }
        var outgoing = val;
        var incoming = document.createElement('span');
        incoming.className = 'ss-qty-roll__val ' + (rising ? 'is-in-up' : 'is-in-down');
        incoming.textContent = next;
        roll.appendChild(incoming);
        val = incoming;
        outgoing.className = 'ss-qty-roll__val ' + (rising ? 'is-out-up' : 'is-out-down');
        window.setTimeout(function () {
          if (outgoing.parentNode) outgoing.parentNode.removeChild(outgoing);
        }, DUR + 40);
      }

      input.addEventListener('focus', function () {
        typing = true;
        host.classList.add('ss-qty-roll-off');
      });
      input.addEventListener('blur', function () {
        typing = false;
        host.classList.remove('ss-qty-roll-off');
        last = input.value;
        val.textContent = input.value;
      });
      /* <quantity-input> dispatches change after stepUp/stepDown. */
      input.addEventListener('change', function () { sync(true); });
      /* The custom hero's .qty-btn writes .value directly and dispatches
         nothing, so read it back on the next tick as well. A second call with
         an unchanged value is a no-op. */
      Array.prototype.forEach.call(host.querySelectorAll('button'), function (btn) {
        btn.addEventListener('click', function () {
          window.setTimeout(function () { sync(true); }, 0);
        });
      });
    }

    function scan(root) {
      var scope = root || document;
      Array.prototype.forEach.call(
        scope.querySelectorAll('quantity-input .quantity__input'),
        attach
      );
    }

    window.SSQtyRoll = { attach: attach, scan: scan };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    /* Section rendering API swaps the buy block wholesale on variant change. */
    document.addEventListener('product-info:loaded', function () { scan(); });
  })();

(function() {
  const scriptEl = document.currentScript;
  const previous = scriptEl && scriptEl.previousElementSibling;
  const configEl = previous && previous.matches('[data-product-hero-config]') ? previous : null;
  if (!configEl) return;
  const config = JSON.parse(configEl.textContent);
  const sectionId = config.sectionId;
  const section = document.getElementById('shopify-section-' + sectionId);
  if (!section) return;

  /* Document-level listeners outlive the section that registered them. In the
     theme editor a section re-render runs this script again, and every run used
     to leave its predecessor attached to a detached DOM — handlers stacking up
     with each edit. One slot per (section, group): the previous handler comes
     off before the new one goes on. */
  const docListeners = (window.__ssPdpDocListeners = window.__ssPdpDocListeners || {});
  function bindDocListener(type, group, handler) {
    const slot = sectionId + ':' + type + ':' + group;
    if (docListeners[slot]) document.removeEventListener(type, docListeners[slot]);
    docListeners[slot] = handler;
    document.addEventListener(type, handler);
  }

  // ============================================
  // STATE - Synced with Shopify
  // ============================================
  let currentVariantEl = section.querySelector('.variant-option.active');
  let isSubscribed = false;
  const discountRate = config.discountRate;
  const unitSuffix = config.unitSuffix;

  // Shopify money format helper - respects customer's selected currency from localization
  const shopCurrency = config.shopCurrency;
  const currencySymbol = config.currencySymbol;

  function formatMoney(cents) {
    // Whole amounts print without ",00" / ".00", the shape of every Liquid price
    // on the page (money_without_trailing_zeros): "108 zł", "12,99 zł", "£22".
    const whole = Math.round(cents) % 100 === 0;
    const lang = config.locale || document.documentElement.lang || 'en';
    // The one money shape (snippets/money.liquid, shapeMoney in the cart drawer):
    // "69 €" in German, "€ 69" in Dutch. The drawer engine exposes it once loaded.
    if (typeof window !== 'undefined' && typeof window.SacrasoulMoney === 'function') {
      return window.SacrasoulMoney(cents, shopCurrency, lang, currencySymbol);
    }
    // Before the engine loads: the four translated languages read Intl, which
    // writes money natively for them; Shopify's formatter writes by currency.
    const nativeLang = /^(de|nl|cs|pl)/i.test(lang);
    if (!nativeLang && typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      const out = Shopify.formatMoney(cents);
      return whole ? String(out).replace(/[.,]00(?!\d)/, '') : out;
    }
    // Fallback: use Intl with narrowSymbol to show zł instead of PLN, € instead of EUR, etc.
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: shopCurrency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(amount);
    } catch (e) {
      // Final fallback: use the symbol from Liquid
      return currencySymbol + (whole ? String(amount) : amount.toFixed(2));
    }
  }

  // Elements
  const mainImage = document.getElementById('mainImage-' + sectionId);
  const thumbnailGrid = document.getElementById('thumbnailGrid-' + sectionId);
  const thumbnails = thumbnailGrid ? thumbnailGrid.querySelectorAll('.thumbnail') : [];
  const variantGrid = document.getElementById('variantGrid-' + sectionId);
  const variantOptions = variantGrid ? variantGrid.querySelectorAll('.variant-option') : [];
  const variantInput = document.getElementById('variantInput-' + sectionId);
  const subscribeToggle = document.getElementById('subscribeToggle-' + sectionId);
  const ritualBenefits = document.getElementById('ritualBenefits-' + sectionId);
  const frequencySelector = document.getElementById('frequencySelector-' + sectionId);
  const qtyInput = document.getElementById('qty-' + sectionId);
  const qtyHidden = document.getElementById('qtyHidden-' + sectionId);
  const stockCountEl = document.getElementById('stockCount-' + sectionId);
  const stockCountMobileEl = document.getElementById('stockCountMobile-' + sectionId);
  const displayPrice = document.getElementById('displayPrice-' + sectionId);
  const originalPrice = document.getElementById('originalPrice-' + sectionId);
  const savingsBadge = document.getElementById('savingsBadge-' + sectionId);
  const ctaPrice = document.getElementById('ctaPrice-' + sectionId);
  const perGramPrice = document.getElementById('perGramPrice-' + sectionId);
  const bagInfoEl = document.getElementById('bagInfo-' + sectionId);
  const mobilePrice = document.getElementById('mobilePrice-' + sectionId);
  const mobilePriceUnit = document.getElementById('mobilePriceUnit-' + sectionId);
  const mobileCta = document.getElementById('mobileCta-' + sectionId);
  const productForm = document.getElementById('productForm-' + sectionId);

  /* Which surface started the current add. The three add buttons share one
     form and one state machine, so the only way an error can find its way
     back to the button that was actually pressed is for that button to say
     so on the way in. atcSubmitOrigin is the claim a button stakes before it
     submits; the submit handler takes it (leaving 'form' behind, so a claim
     dropped by an early guard cannot mislead the next press) and holds it in
     atcActiveOrigin for as long as that add is in flight. */
  let atcSubmitOrigin = 'form';
  let atcActiveOrigin = 'form';

  // ============================================
  // FORM SUBMIT, AJAX add-to-cart + open drawer
  // ============================================
  if (productForm) {
    var atcButton = productForm.querySelector('.cta-btn, button[type="submit"]');
    var atcMsg = document.getElementById('atcMsg-' + sectionId);
    var cartStrings = config.cartStrings || {};
    /* Both surfaces morph: on desktop the customer presses .cta-btn, on a
       phone they usually press the sticky bar. A state that only ever appears
       on the button they cannot see is no feedback at all. */
    var atcButtons = [];
    if (atcButton) atcButtons.push(atcButton);
    var atcMobileBtn = document.getElementById('mobileCta-' + sectionId);
    if (atcMobileBtn) atcButtons.push(atcMobileBtn);
    /* Third surface, same reasoning: once the buy panel has scrolled away the
       desktop bar IS the button being pressed, so the state has to land on it. */
    var atcBarBtn = document.getElementById('pdpBuyBarCta-' + sectionId);
    if (atcBarBtn) atcButtons.push(atcBarBtn);
    var atcRevertTimer = null;
    /* The morph is pure colour and motion, which reaches nobody using a
       screen reader. This node carries the words. Success always speaks here;
       failure speaks here too UNLESS the buy bar started the add, in which
       case the bar's own line does the talking (see atcFail) so the same
       sentence is never read out twice. "Adding…" is deliberately never
       announced: it is chatter in front of the answer. */
    var atcSrStatus = document.getElementById('atcSrStatus-' + sectionId);
    var atcBarMsg = document.getElementById('pdpBuyBarMsg-' + sectionId);

    function atcAnnounce(text) {
      if (!atcSrStatus || !text) return;
      /* Same string twice in a row is not a DOM change, so nothing would be
         read. Clear first, then write on the next frame. */
      atcSrStatus.textContent = '';
      window.setTimeout(function () { atcSrStatus.textContent = text; }, 60);
    }

    /* One failure, shown where the shopper is looking. The visible line under
       the buy row always carries it (it is the form's own error slot); when
       the press came from the bar, the bar gets the line too — off-screen
       text is no message at all — and the bar's live region announces it.
       Focus is never moved: yanking a keyboard user out of the bar to a form
       four screens up is worse than the error itself. */
    function atcFail() {
      var text = cartStrings.retry || 'Try again';
      if (atcMsg) atcMsg.textContent = text;
      if (atcActiveOrigin === 'buybar' && atcBarMsg) {
        atcBarMsg.textContent = text;
      } else {
        atcAnnounce(text);
      }
    }

    function atcClearMessages() {
      if (atcMsg) atcMsg.textContent = '';
      if (atcBarMsg) atcBarMsg.textContent = '';
    }

    function atcSetState(state, label) {
      window.clearTimeout(atcRevertTimer);
      atcButtons.forEach(function (btn) {
        var slot = btn.querySelector('.cta-btn__state');
        if (slot) slot.textContent = label || '';
        btn.classList.toggle('is-atc-working', state === 'working');
        btn.classList.toggle('is-atc-added', state === 'added');
        /* is-busy is the pre-existing press affordance; keep it tied to the
           states that must not take a second tap. */
        btn.classList.toggle('is-busy', state === 'working' || state === 'added');
        if (state === 'working' || state === 'added') {
          btn.setAttribute('aria-busy', 'true');
        } else {
          btn.removeAttribute('aria-busy');
        }
      });
    }

    function atcRevert(delay) {
      window.clearTimeout(atcRevertTimer);
      atcRevertTimer = window.setTimeout(function () { atcSetState('idle', ''); }, delay || 0);
    }

    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var formData = new FormData(productForm);
      var variantId = formData.get('id');
      var qty = parseInt(formData.get('quantity') || '1', 10);
      if (!variantId) return;

      /* block submit if the selected variant is sold-out */
      var activeOpt = variantGrid && variantGrid.querySelector('.variant-option.active');
      if (activeOpt && activeOpt.classList.contains('sold-out')) return;
      if (activeOpt && activeOpt.dataset.variantAvailable === 'false') return;

      /* The press registers immediately with a quiet "Adding…"; "Added" only
         ever appears once the add call has actually resolved, so the button
         never promises something the cart did not do. The drawer stays the
         real celebration — nothing here delays or blocks it. */
      if (atcButton && atcButton.classList.contains('is-busy')) return;
      atcActiveOrigin = atcSubmitOrigin;
      atcSubmitOrigin = 'form';
      atcClearMessages();
      atcSetState('working', cartStrings.adding || 'Adding…');
      /* Safety net: if the cart engine is missing entirely, or resolves in a
         way we never see, the button must not stay stuck. */
      atcRevert(6000);

      /* multipack tiers: when the active variant tile carries a pack-size > 1,
         multiply the cart quantity so adding "5 bottles" sends qty=5 of the
         base 6ml variant. Pricing is later reconciled via a Shopify automatic
         discount that recognises the multipack thresholds. */
      if (activeOpt && activeOpt.dataset.packSize) {
        var packSize = parseInt(activeOpt.dataset.packSize, 10);
        if (packSize > 1) qty = qty * packSize;
      }

      /* A Shopify subscription is a top-level cart item field, not a line-item
         property. Pass the selected selling-plan ID separately to the cart engine. */
      var props = {};
      var sellingPlan = formData.get('selling_plan') || undefined;

      /* use cart drawer's optimised addAndOpen with instant preview */
      if (window.SacrasoulCart && window.SacrasoulCart.addAndOpen) {
        var propsArg = Object.keys(props).length ? props : undefined;
        var preview = window.SacrasoulCart.buildPreview
          ? window.SacrasoulCart.buildPreview(productForm, variantId, qty, propsArg)
          : null;
        /* addAndOpen returns a real Promise: it resolves with the reconciled
           cart object and rejects with the add error (see the classification
           in sacrasoul-cart-drawer.js — ssInventory / ssCartUncertain). That
           resolution is the ONLY thing allowed to say "Added". */
        var addPromise = window.SacrasoulCart.addAndOpen(variantId, qty, propsArg, preview, sellingPlan);
        if (addPromise && typeof addPromise.then === 'function') {
          addPromise.then(function () {
            atcSetState('added', cartStrings.added || 'Added');
            atcAnnounce(cartStrings.added || 'Added');
            atcActiveOrigin = 'form';
            atcRevert(1200);
          }, function () {
            atcSetState('idle', '');
            atcFail();
            atcActiveOrigin = 'form';
          });
        } else {
          /* No promise handed back (older drawer build): fall back to the
             behaviour event the drawer emits on document. */
          atcRevert(1200);
        }
      } else {
        atcSetState('idle', '');
      }
    });

    /* Belt and braces for the no-promise path above, and for any add started
       elsewhere on the page: the drawer emits sacrasoul:behavior with
       cart_item_added / cart_add_* names. Harmless when the promise already
       settled, because atcSetState clears the pending revert. */
    bindDocListener('sacrasoul:behavior', 'atc-fallback', function (ev) {
      var name = ev && ev.detail && ev.detail.name;
      if (!name) return;
      var working = atcButtons.some(function (b) { return b.classList.contains('is-atc-working'); });
      if (!working) return;
      if (name === 'cart_item_added') {
        atcSetState('added', cartStrings.added || 'Added');
        atcAnnounce(cartStrings.added || 'Added');
        atcActiveOrigin = 'form';
        atcRevert(1200);
      } else if (name === 'cart_add_failed' || name === 'cart_add_unavailable' || name === 'cart_add_uncertain') {
        /* Only an add that ended counts. The engine also emits
           cart_add_heal_attempted / cart_add_heal_succeeded in the middle of
           an add that is still going to land (tests/browser/pdp-heal-state-proof.mjs). */
        atcSetState('idle', '');
        atcFail();
        atcActiveOrigin = 'form';
      }
    });

    /* ── One specular pass, once per session ──────────────────────────────
       Gated on data-atc-light-pass on the form (present in this build, remove
       the attribute to kill the effect). Fires when the button first comes
       into view, never loops, never under reduced motion. */
    if (productForm.hasAttribute('data-atc-light-pass') && atcButton && 'IntersectionObserver' in window) {
      var lightPassKey = 'ss-atc-light-pass';
      var alreadyPassed = false;
      try { alreadyPassed = window.sessionStorage.getItem(lightPassKey) === '1'; } catch (err) {}
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!alreadyPassed && !reduceMotion) {
        var lightObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            lightObserver.disconnect();
            try { window.sessionStorage.setItem(lightPassKey, '1'); } catch (err) {}
            atcButton.classList.add('is-light-pass');
            window.setTimeout(function () { atcButton.classList.remove('is-light-pass'); }, 2600);
          });
        }, { threshold: 0.6 });
        lightObserver.observe(atcButton);
      }
    }
  }

  let currentImageIndex = 0;
  let stockCount = config.stockCount;
  const stockIsSoldOut = config.stockIsSoldOut;

  // The displayed stock number reflects actual inventory at page load
  // (see smart_stock above). We don't tick it down during the session.
  // Manufactured urgency is a brand violation; if a real order lands,
  // the next page load reflects it. The IDs stay so server-rendered
  // updates (variant-change handlers below) can still mutate the number.
  function updateStockDisplay() {
    if (stockCountEl) stockCountEl.textContent = stockCount;
    if (stockCountMobileEl) stockCountMobileEl.textContent = stockCount;
  }

  // ============================================
  // IMAGE GALLERY
  // ============================================
  function buildResponsiveSrcset(src) {
    // Shopify CDN URLs carry ?width=N; swap it to build a responsive set.
    // Includes higher widths for Retina/4K displays. Shopify clamps to the
    // source image size, so over-requesting is safe.
    if (!src || !/[?&]width=\d+/.test(src)) return '';
    return [600, 800, 1200, 1600, 2000]
      .map(w => src.replace(/(width=)\d+/, '$1' + w) + ' ' + w + 'w')
      .join(', ');
  }

  // ============================================
  // GALLERY POSITION RAIL
  //
  // "01 / 04" plus a hairline whose filled segment tracks position. It follows
  // two different signals on purpose: a tap, arrow or swipe moves it via
  // updateMainImage, and dragging the thumbnail strip moves it from the
  // strip's real scroll offset — so on a phone the indicator answers the
  // gesture the customer is actually making, not the last one they finished.
  // ============================================
  const galleryRail = document.getElementById('galleryRail-' + sectionId);
  const galleryIndexEl = document.getElementById('galleryIndex-' + sectionId);
  const galleryFill = document.getElementById('galleryFill-' + sectionId);
  const galleryLive = document.getElementById('galleryLive-' + sectionId);
  const galleryTotal = thumbnails.length;
  let railIndex = -1;
  let railAnnounceTimer = null;
  let railSuppressScrollUntil = 0;

  function railPad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function railSet(index) {
    if (!galleryRail || galleryTotal < 2) return;
    const clamped = Math.max(0, Math.min(galleryTotal - 1, index));
    if (clamped === railIndex) return;
    railIndex = clamped;
    if (galleryIndexEl) galleryIndexEl.textContent = railPad(clamped + 1);
    if (galleryFill) {
      galleryFill.style.transform = 'translateX(' + (clamped * 100) + '%)';
    }
    /* Throttled: a swipe through five images should leave one announcement
       behind it, not five. */
    if (galleryLive) {
      window.clearTimeout(railAnnounceTimer);
      railAnnounceTimer = window.setTimeout(function () {
        const template = config.galleryAnnounce || 'Image {index} of {total}';
        galleryLive.textContent = template
          .replace('{index}', String(clamped + 1))
          .replace('{total}', String(galleryTotal));
      }, 350);
    }
  }

  if (galleryRail && galleryTotal > 1) {
    if (galleryFill) galleryFill.style.width = (100 / galleryTotal) + '%';
    railSet(0);

    if (thumbnailGrid) {
      let railScrollTicking = false;
      thumbnailGrid.addEventListener('scroll', function () {
        if (railScrollTicking) return;
        railScrollTicking = true;
        window.requestAnimationFrame(function () {
          railScrollTicking = false;
          if (Date.now() < railSuppressScrollUntil) return;
          /* Whichever thumbnail sits closest to the middle of the strip is the
             one the customer is looking at. */
          const mid = thumbnailGrid.scrollLeft + thumbnailGrid.clientWidth / 2;
          let best = 0;
          let bestDist = Infinity;
          thumbnails.forEach(function (t, i) {
            const center = t.offsetLeft + t.offsetWidth / 2;
            const dist = Math.abs(center - mid);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          railSet(best);
        });
      }, { passive: true });
    }
  }

  // Guards the swap against out-of-order resolution: a rapid second tap bumps
  // the token, so the first tap's decode callback knows it lost and bails.
  let swapToken = 0;

  function updateMainImage(index) {
    const thumb = thumbnails[index];
    if (!thumb || !mainImage) return;

    const src = thumb.dataset.src || thumb.querySelector('img').src.replace(/w=\d+/, 'w=800');
    const srcset = buildResponsiveSrcset(src);
    // Skip the unveil animation when the click landed on the already-active
    // image (e.g., re-tapping the same thumbnail), no visible change should
    // trigger no animation.
    const isDifferentImage = index !== currentImageIndex;
    // The thumbnail rail and the index answer immediately; only the pixels wait.
    thumbnails.forEach((t, i) => t.classList.toggle('active', i === index));
    currentImageIndex = index;
    railSet(index);
    /* Centre the active thumbnail in the strip, and hold the scroll listener
       off while that programmatic scroll settles so it cannot argue with the
       index we just set. The strip is scrolled directly rather than through
       scrollIntoView, which is free to move the whole page vertically. */
    if (galleryRail && thumbnailGrid && thumbnailGrid.scrollWidth > thumbnailGrid.clientWidth) {
      railSuppressScrollUntil = Date.now() + 600;
      const maxScroll = thumbnailGrid.scrollWidth - thumbnailGrid.clientWidth;
      const target = Math.max(0, Math.min(
        maxScroll,
        thumb.offsetLeft - (thumbnailGrid.clientWidth - thumb.offsetWidth) / 2
      ));
      try {
        thumbnailGrid.scrollTo({
          left: target,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      } catch (err) {
        thumbnailGrid.scrollLeft = target;
      }
    }

    const token = ++swapToken;
    let done = false;
    const commit = () => {
      if (done || token !== swapToken) return; // a newer tap won
      done = true;
      if (isDifferentImage) {
        // The image is "unveiled", old recedes into a fade, new settles in
        // from a hair larger (1.5% scale). Adds 0.7 s of ceremony to a click.
        mainImage.classList.remove('main-image--unveiling');
        void mainImage.offsetWidth; /* force reflow so the animation restarts */
      }
      // Update srcset BEFORE src so the browser picks from the new responsive
      // set instead of the stale srcset pointing at the featured image.
      mainImage.srcset = srcset;
      mainImage.src = src;
      // Back-nav morphs the collection card into this element; only the featured
      // shot (index 0) is the honest pair, so drop the name on other images.
      if (mainImage.dataset.ssVt === undefined) mainImage.dataset.ssVt = mainImage.style.viewTransitionName;
      mainImage.style.viewTransitionName = index === 0 ? mainImage.dataset.ssVt : 'none';
      if (isDifferentImage) {
        mainImage.classList.add('main-image--unveiling');
      }
    };

    // Decode first, then swap, so the ceremony never plays against a stale
    // frame on a cold tap. The detached Image carries the SAME sizes and
    // srcset the <img> will resolve against, or the browser picks a different
    // candidate and downloads it twice.
    const pre = new Image();
    pre.decoding = 'async';
    const sizes = mainImage.getAttribute('sizes');
    if (sizes) pre.sizes = sizes;
    if (srcset) pre.srcset = srcset;
    pre.src = src;
    // decode() rejects with EncodingError if the source changes mid-flight, so
    // both paths commit: a cosmetic glitch beats a gallery that stops updating.
    if (pre.decode) pre.decode().then(commit, commit);
    else pre.onload = pre.onerror = commit;
    setTimeout(commit, 400); // never let a stalled network freeze the gallery
  }

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => updateMainImage(index));
  });

  function stepGallery(direction) {
    if (thumbnails.length < 2) return;
    if (direction === 'prev') {
      currentImageIndex = (currentImageIndex - 1 + thumbnails.length) % thumbnails.length;
    } else {
      currentImageIndex = (currentImageIndex + 1) % thumbnails.length;
    }
    updateMainImage(currentImageIndex);
  }

  // Main image arrows
  section.querySelectorAll('.main-image-arrow').forEach(arrow => {
    arrow.addEventListener('click', () => {
      stepGallery(arrow.dataset.action === 'prev' ? 'prev' : 'next');
    });
  });

  /* Swipe. THE one handler for .main-image-wrapper. Do not add a second.
     This gallery swaps one <img>'s src rather than scrolling a track, so it
     never had a swipe, while the markup's own sibling gallery advertises one
     and the warm-cache comment below already assumes one exists. Real visitors
     swiped it anyway: PostHog logged dead swipes on .main-image across the
     hero-gallery PDPs (22-27 Jul), alongside rage clicks on these arrows.
     Two independent touchstart/touchend pairs then ended up on this same
     wrapper: this block and an older one that drove updateMainImage directly.
     Both fired on every swipe, so one flick advanced two images and the swipe
     read as broken (dead_swipe on sultans-jade, quick-lighting-charcoal,
     27-28 Jul). Everything both blocks did lives here now, once.
     Horizontal intent only; a vertical drag stays a page scroll. Zoom is
     intentionally NOT wired: some product imagery is AI-generated and not
     pixel-accurate to what ships, so we don't invite close inspection. */
  const imageWrapper = section.querySelector('.main-image-wrapper');
  if (imageWrapper && thumbnails.length > 1) {
    const SWIPE_MIN_PX = 40;        // shorter than this is a tap, not a swipe
    const SWIPE_FLICK_PX = 24;      // a fast flick commits on less distance
    const SWIPE_FLICK_VELOCITY = 0.4; // px/ms
    const SWIPE_MAX_MS = 800;       // slower than this is a considered drag
    let startX = 0, startY = 0, startT = 0, tracking = false;

    imageWrapper.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startT = Date.now();
      tracking = true;
    }, { passive: true });

    // A drag that turns mostly vertical is the page being scrolled: let go of
    // it mid-gesture rather than judging it at the end.
    imageWrapper.addEventListener('touchmove', (e) => {
      if (!tracking || e.touches.length !== 1) return;
      const dx = Math.abs(e.touches[0].clientX - startX);
      const dy = Math.abs(e.touches[0].clientY - startY);
      if (dy > dx * 1.4) tracking = false;
    }, { passive: true });

    imageWrapper.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;
      const touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      const elapsed = Date.now() - startT;
      if (elapsed > SWIPE_MAX_MS) return;
      // Let a diagonal that is mostly vertical stay a scroll.
      if (Math.abs(dx) <= Math.abs(dy)) return;
      const velocity = Math.abs(dx) / Math.max(elapsed, 1);
      /* Commit on displacement, or on a quick flick that covered less ground. */
      if (Math.abs(dx) < SWIPE_MIN_PX
          && !(Math.abs(dx) > SWIPE_FLICK_PX && velocity > SWIPE_FLICK_VELOCITY)) return;
      stepGallery(dx > 0 ? 'prev' : 'next');
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch (err) {} }
    }, { passive: true });

    imageWrapper.addEventListener('touchcancel', () => { tracking = false; }, { passive: true });
  }

  // Warm-cache the remaining product images so subsequent gallery clicks
  // feel instant. Deferred until ANY of:
  //   1. First scroll past 100 px (real interest signal)
  //   2. Customer hovers a thumbnail (about to click)
  //   3. Customer interacts with a variant (likely to flip images)
  // The featured image is already eager-loaded so this is purely
  // a click-feels-instant optimisation, not LCP-critical.
  const sizesAttr = (mainImage && mainImage.getAttribute('sizes')) || '(max-width: 768px) 100vw, 600px';
  // A cursor, not a boolean: the scroll pass warms the first few and a later
  // intent signal picks up where it left off. Starts at 1 because index 0 is
  // the featured image, already eager-loaded — so warmGalleryCache(3) really
  // warms the three images a swipe reaches next (1, 2, 3), not two.
  let warmedUpTo = 1;
  const warmGalleryCache = (limit) => {
    const stop = Math.min(
      limit == null ? thumbnails.length : warmedUpTo + limit,
      thumbnails.length
    );
    for (let i = Math.max(warmedUpTo, 1); i < stop; i++) {
      const src = thumbnails[i].dataset.src;
      if (!src) continue;
      const srcset = buildResponsiveSrcset(src);
      const img = new Image();
      img.decoding = 'async';
      if (srcset) {
        img.sizes = sizesAttr;
        img.srcset = srcset;
      }
      img.src = src;
    }
    warmedUpTo = Math.max(warmedUpTo, stop);
  };
  if (thumbnails.length > 1) {
    // Scroll past 100px is interest, not intent: warm the three images a swipe
    // or an arrow reaches next, at idle, and not at all for a visitor who has
    // asked the browser for Data Saver or is on 2G. Same predicate as
    // assets/product-bundle-pdp.js:33.
    const conn = navigator.connection || {};
    const warmOK = !conn.saveData && !/(^|-)2g$/.test(conn.effectiveType || '');
    if (warmOK) {
      const onFirstScroll = () => {
        if (window.scrollY > 100) {
          window.removeEventListener('scroll', onFirstScroll);
          const go = () => warmGalleryCache(3);
          if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2000 });
          else setTimeout(go, 600);
        }
      };
      window.addEventListener('scroll', onFirstScroll, { passive: true });
    }
    // Intent triggers stay UNCAPPED and UNGUARDED: an explicit hover, tap or
    // variant click means the customer is in the gallery, so warm the rest.
    thumbnails.forEach(t => {
      t.addEventListener('mouseenter', () => warmGalleryCache(), { once: true });
      t.addEventListener('touchstart', () => warmGalleryCache(), { once: true, passive: true });
    });
    if (variantGrid) {
      variantGrid.addEventListener('click', () => warmGalleryCache(), { once: true });
    }
  }

  // ============================================
  // VARIANT SELECTION - Synced with Shopify
  // ============================================
  function selectVariant(el) {
    if (el.classList.contains('sold-out')) return;
    variantOptions.forEach(v => v.classList.remove('active'));
    el.classList.add('active');
    currentVariantEl = el;

    // Update hidden variant input for form submission
    const variantId = el.dataset.variantId;
    if (variantInput && variantId) {
      variantInput.value = variantId;
    }

    // Enable CTA button
    const ctaBtn = section.querySelector('.cta-btn');
    if (ctaBtn) ctaBtn.classList.remove('disabled');

    // Only the "Only N left" badge carries variant-specific data. When the
    // user picks a different variant, the rendered number is stale, so we
    // hide that pill. The "Limited batch" and "Sold out" pills are stable
    // across variants (every Sacrasoul item is from a limited batch, and
    // sold-out state is handled by the form/variant code separately).
    const numberedBadges = section.querySelectorAll(
      '.badge-pill:not(.badge-pill--sold-out):not(.badge-pill--limited), ' +
      '.stock-line:not(.stock-line--sold-out):not(.stock-line--limited)'
    );
    numberedBadges.forEach(b => { b.style.display = 'none'; });

    updatePricing();
  }

  variantOptions.forEach(option => {
    option.addEventListener('click', function() {
      selectVariant(this);
    });
  });

  // ============================================
  // INIT: disable CTA if initial variant is sold-out
  // (handles URL param ?variant=... pointing to an unavailable variant)
  // ============================================
  (function() {
    const activeVariant = variantGrid && variantGrid.querySelector('.variant-option.active');
    if (activeVariant && activeVariant.classList.contains('sold-out')) {
      const ctaBtn = section.querySelector('.cta-btn');
      if (ctaBtn) ctaBtn.classList.add('disabled');
      if (mobileCta) mobileCta.classList.add('disabled');
    }
  })();

  // ============================================
  // SUBSCRIPTION - Appstle Integration
  // ============================================
  const sellingPlanInput = document.getElementById('sellingPlanInput-' + sectionId);
  let selectedSellingPlanId = null;

  // Get selling plan data from Liquid
  const sellingPlansData = config.sellingPlans || {};

  // Get the first selling plan ID as default
  const defaultSellingPlanId = Object.keys(sellingPlansData)[0] || null;

  if (subscribeToggle) {
    subscribeToggle.addEventListener('change', function() {
      isSubscribed = this.checked;

      if (ritualBenefits) ritualBenefits.classList.toggle('show', isSubscribed);
      if (frequencySelector) frequencySelector.classList.toggle('show', isSubscribed);

      // Update selling plan input
      if (isSubscribed) {
        // Get currently selected frequency's selling plan ID
        const activeFreq = section.querySelector('.frequency-option.active');
        selectedSellingPlanId = activeFreq ? activeFreq.dataset.sellingPlanId : defaultSellingPlanId;
      } else {
        selectedSellingPlanId = null;
      }

      if (sellingPlanInput) {
        sellingPlanInput.value = selectedSellingPlanId || '';
      }

      updatePricing();
    });
  }

  // Frequency options - update selling plan ID when changed
  section.querySelectorAll('.frequency-option').forEach(opt => {
    opt.addEventListener('click', function() {
      section.querySelectorAll('.frequency-option').forEach(o => o.classList.remove('active'));
      this.classList.add('active');

      // Update the selected selling plan ID
      if (isSubscribed) {
        selectedSellingPlanId = this.dataset.sellingPlanId || null;
        if (sellingPlanInput) {
          sellingPlanInput.value = selectedSellingPlanId || '';
        }
      }
    });
  });

  // ============================================
  // PRICING UPDATES - Using Shopify & Appstle data
  // ============================================
  function getSubscriptionDiscount() {
    // Get discount from selected selling plan, or fallback to settings
    if (selectedSellingPlanId && sellingPlansData[selectedSellingPlanId]) {
      const plan = sellingPlansData[selectedSellingPlanId];
      if (plan.discountType === 'percentage') {
        return plan.discountValue / 100; // e.g., 20 becomes 0.20
      } else if (plan.discountType === 'fixed_amount') {
        return plan.discountValue; // Return fixed amount in cents
      }
    }
    // Fallback to settings-based discount rate (as decimal, e.g., 0.20 for 20% off)
    return 1 - discountRate; // discountRate is 0.80 for 20% off, so this gives 0.20
  }

  function calculateSubscriptionPrice(priceCents) {
    if (!isSubscribed) return priceCents;

    const plan = selectedSellingPlanId ? sellingPlansData[selectedSellingPlanId] : null;

    if (plan) {
      if (plan.discountType === 'percentage') {
        return Math.round(priceCents * (100 - plan.discountValue) / 100);
      } else if (plan.discountType === 'fixed_amount') {
        return Math.max(0, priceCents - plan.discountValue);
      }
    }

    // Fallback: use settings discount rate
    return Math.round(priceCents * discountRate);
  }

  function updatePricing() {
    if (!currentVariantEl) return;

    const priceCents = parseInt(currentVariantEl.dataset.price) || 0;
    const compareCents = parseInt(currentVariantEl.dataset.comparePrice) || priceCents;
    const weight = parseFloat(currentVariantEl.dataset.weight) || 1;
    const bagInfo = currentVariantEl.dataset.bagInfo || '';
    const variantIndex = Array.from(section.querySelectorAll('.variant-option')).indexOf(currentVariantEl) + 1;

    // Apply subscription discount if active (using Appstle selling plan data)
    const finalCents = calculateSubscriptionPrice(priceCents);
    const perGramCents = Math.round(finalCents / weight);
    const savings = priceCents - finalCents;

    // Update main price display
    if (displayPrice) displayPrice.textContent = formatMoney(finalCents);
    if (ctaPrice) ctaPrice.textContent = formatMoney(finalCents);
    if (perGramPrice) perGramPrice.textContent = formatMoney(perGramCents) + '/' + unitSuffix;

    // Update bag info with translation support
    if (bagInfoEl) {
      // Check if we have translation system available
      if (window.SacrasoulI18n && window.SacrasoulI18n.initialized) {
        const translatedBagInfo = window.SacrasoulI18n.t('hero.variant_' + variantIndex + '_bag_info');
        bagInfoEl.textContent = translatedBagInfo || bagInfo;
        bagInfoEl.setAttribute('data-translate-key', 'hero.variant_' + variantIndex + '_bag_info');
      } else {
        bagInfoEl.textContent = bagInfo;
      }
      /* the separator dot only earns its place when there is bag info to follow it */
      const bagInfoSep = document.getElementById('bagInfoSep-' + sectionId);
      if (bagInfoSep) {
        bagInfoSep.hidden = !(bagInfoEl.textContent || '').trim();
      }
    }

    // Update mobile sticky CTA
    if (mobilePrice) mobilePrice.textContent = formatMoney(finalCents);
    if (mobilePriceUnit) mobilePriceUnit.textContent = weight + unitSuffix;

    // Show/hide savings badge
    if (isSubscribed && savings > 0) {
      if (originalPrice) {
        originalPrice.textContent = formatMoney(priceCents);
        originalPrice.classList.add('show');
      }
      if (savingsBadge) {
        savingsBadge.textContent = 'Save ' + formatMoney(savings);
        savingsBadge.classList.add('show');
      }
    } else {
      if (originalPrice) originalPrice.classList.remove('show');
      if (savingsBadge) savingsBadge.classList.remove('show');
    }

    // Update all variant cards with subscription pricing
    variantOptions.forEach(option => {
      const optPrice = parseInt(option.dataset.price) || 0;
      const optWeight = parseFloat(option.dataset.weight) || 1;
      const optPack = parseInt(option.dataset.packSize) || 1;
      const cardPrice = calculateSubscriptionPrice(optPrice);
      const cardPerGram = Math.round(cardPrice / optWeight);

      const priceEl = option.querySelector('.variant-price');
      const unitEl = option.querySelector('.variant-unit-price');

      if (priceEl) priceEl.textContent = formatMoney(cardPrice);
      if (unitEl) unitEl.textContent = formatMoney(cardPerGram) + '/' + unitSuffix;
    });
  }

  // ============================================
  // QUANTITY
  // ============================================
  section.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      let val = parseInt(qtyInput.value);
      const action = this.dataset.action;

      if (action === 'decrease') {
        val = Math.max(1, val - 1);
      } else {
        val = Math.min(10, val + 1);
      }

      qtyInput.value = val;
      if (qtyHidden) qtyHidden.value = val;
    });
  });

  /* Rolling digit on the hero stepper (SSQtyRoll, defined at the top of this
     file). Display only: qtyInput stays the source of truth for the form. */
  function attachHeroQtyRoll() {
    if (qtyInput && window.SSQtyRoll) window.SSQtyRoll.attach(qtyInput);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachHeroQtyRoll);
  } else {
    attachHeroQtyRoll();
  }

  // ============================================
  // ACCORDIONS
  // ============================================
  section.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const accordion = this.parentElement;
      const isActive = accordion.classList.contains('active');

      section.querySelectorAll('.accordion').forEach(a => {
        a.classList.remove('active');
        a.querySelector('.accordion-header .accordion-icon').textContent = '+';
      });

      if (!isActive) {
        accordion.classList.add('active');
      }
    });
  });

  // ============================================
  // MOBILE CTA - Click handler
  // ============================================
  if (mobileCta && productForm) {
    mobileCta.addEventListener('click', function() {
      productForm.requestSubmit();
    });
  }

  // ============================================
  // MOBILE STICKY CTA - Show only within hero section
  // ============================================
  const mobileStickyBar = section.parentElement.querySelector('.mobile-sticky-cta');
  const heroSection = section.querySelector('.product-hero');

  function updateStickyVisibility() {
    if (!mobileStickyBar || window.innerWidth > 989) return;

    /* .sold-out-card__notify .notify-morph__stage replaced the old
       .sold-out-card__cta button when the modal became an in-place morph; the
       stage is what now occupies that footprint, so it is what decides whether
       the inline CTA is on screen. */
    var ctaButton = heroSection
      ? heroSection.querySelector('.cta-btn, .sold-out-card__notify .notify-morph__stage')
      : null;
    var ctaRect = ctaButton ? ctaButton.getBoundingClientRect() : null;

    // The inline CTA is truly "in view" only if it is rendered (has size) AND
    // its bounding box overlaps the visible viewport
    var inView = ctaRect
      && ctaRect.height > 0
      && ctaRect.width > 0
      && ctaRect.bottom > 0
      && ctaRect.top < window.innerHeight;

    if (inView) {
      // User can see the inline CTA right now, hide the sticky bar
      mobileStickyBar.classList.remove('visible');
    } else {
      // Inline CTA is either hidden, above viewport, or below viewport
      //, always give the user a way to add to cart via the sticky bar
      mobileStickyBar.classList.add('visible');
    }
  }

  // Throttled scroll handler
  let scrollTicking = false;
  window.addEventListener('scroll', function() {
    if (!scrollTicking) {
      window.requestAnimationFrame(function() {
        updateStickyVisibility();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  // Initial check
  updateStickyVisibility();

  // ============================================
  // NOTIFY ME - IN-PLACE MORPH
  //
  // The overlay modal is gone. One .notify-morph per section widens the
  // sold-out CTA into an email field inside its own reserved footprint and
  // settles into a confirmation line. Every trigger (sold-out card, sold-out
  // variant tile, pre-order line, mobile sticky bar) routes here; the two
  // writes the modal made are preserved exactly:
  //   1. the Klaviyo back-in-stock subscription (unchanged, below)
  //   2. the Shopify customer record via a real Liquid customer-form POST,
  //      same contact[tags] and contact[note] as before
  // ============================================
  const notifyMorph = document.getElementById('notifyMorph-' + sectionId);
  const notifyHost = notifyMorph ? notifyMorph.closest('[data-notify-host]') : null;
  const notifyHostStartsHidden = !!(notifyHost && notifyHost.hasAttribute('hidden'));
  const notifyForm = document.getElementById('notify-form-' + sectionId);
  const notifyNote = document.getElementById('notify-note-' + sectionId);
  const notifyTags = document.getElementById('notify-tags-' + sectionId);
  const notifyTrigger = document.getElementById('notifyTrigger-' + sectionId);
  const notifyEmailInput = document.getElementById('notify-email-' + sectionId);
  const notifyMsg = document.getElementById('notify-msg-' + sectionId);
  const notifyStrings = config.notifyStrings || {};

  let notifyVariantId = '';
  let notifyLastTrigger = null;
  /* The variant the shopper has actually subscribed to this page load. The
     done state belongs to THAT variant: it persists until they pick a
     different sold-out one, or the page reloads. Nothing on a timer. */
  let notifySubscribedVariantId = '';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function notifyState() {
    return notifyMorph ? (notifyMorph.dataset.state || 'idle') : 'idle';
  }

  function notifySetState(state) {
    if (!notifyMorph) return;
    notifyMorph.dataset.state = state;
    if (notifyTrigger) {
      notifyTrigger.setAttribute('aria-expanded', state === 'open' || state === 'sending' ? 'true' : 'false');
    }
  }

  /* One live region for both outcomes. The error is shown; the confirmation is
     announced only, because the visible confirmation is the morph itself and
     hearing it twice is noise. */
  function notifyMessage(text, srOnly) {
    if (!notifyMsg) return;
    notifyMsg.textContent = text || '';
    notifyMsg.classList.toggle('notify-morph__msg--sr', !!srOnly);
  }

  /* Every notify trigger carries data-notify-variant-id; the enclosing
     .variant-option tile, then the host wrapper, are defensive fallbacks for
     any future trigger added without one. */
  function notifyApplyContext(el) {
    const source = (el && el.dataset && el.dataset.notifyProduct) ? el : notifyHost;
    if (!source || !source.dataset.notifyProduct) return; // never blank out a good note
    const variantName = source.dataset.notifyVariant || '';
    const productName = source.dataset.notifyProduct || '';
    const variantOption = el && el.closest ? el.closest('.variant-option') : null;
    notifyVariantId = source.dataset.notifyVariantId
      || (variantOption && variantOption.dataset.variantId)
      || (notifyHost && notifyHost.dataset.notifyVariantId)
      || '';
    const hasDistinctVariant = variantName && variantName !== productName;
    if (notifyNote) {
      notifyNote.value = hasDistinctVariant
        ? 'Back in Stock: ' + productName + ' - ' + variantName
        : 'Back in Stock: ' + productName;
    }
    const productTag = productName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    if (notifyTags) notifyTags.value = 'back-in-stock, notify, notify-' + productTag;

    /* Re-arm, and ONLY here. This runs on every trigger press, which is the
       variant-change path: a different sold-out variant means a different
       subscription, so the form comes back. The same variant keeps the
       confirmation standing — a shopper who already gave us their email must
       never watch it revert to "Notify me" and wonder if it took. */
    if (notifyState() === 'done' && notifyVariantId && notifyVariantId !== notifySubscribedVariantId) {
      notifyMessage('');
      notifySetState('idle');
    }
  }

  function notifyOpen(triggerEl, shouldScroll) {
    if (!notifyMorph) return;
    notifyLastTrigger = triggerEl || notifyLastTrigger;
    notifyApplyContext(triggerEl);
    /* Still done means the press was for the variant already subscribed:
       leave the confirmation exactly where it is. */
    if (notifyState() === 'done') return;
    if (notifyHost && notifyHost.hasAttribute('hidden')) notifyHost.removeAttribute('hidden');
    notifyMessage('');
    if (notifyEmailInput) notifyEmailInput.removeAttribute('aria-invalid');
    notifySetState('open');
    /* Force the style flush before focusing: the field is visibility:hidden
       until the state attribute lands, and focus() on a still-hidden element
       is a no-op. Focus stays in the same task as the tap so iOS opens the
       keyboard. */
    void notifyMorph.offsetWidth;
    if (notifyEmailInput) {
      try { notifyEmailInput.focus({ preventScroll: true }); } catch (err) { notifyEmailInput.focus(); }
    }
    if (shouldScroll) {
      try {
        notifyMorph.scrollIntoView({ block: 'center', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      } catch (err) {
        notifyMorph.scrollIntoView();
      }
    }
  }

  function notifyCollapse(returnFocus) {
    if (!notifyMorph) return;
    if (notifyState() !== 'open') return;
    notifyMessage('');
    notifySetState('idle');
    if (notifyHostStartsHidden && notifyHost) notifyHost.setAttribute('hidden', '');
    if (returnFocus) {
      const back = (notifyHostStartsHidden && notifyLastTrigger) ? notifyLastTrigger : notifyTrigger;
      if (back) {
        try { back.focus({ preventScroll: true }); } catch (err) { back.focus(); }
      }
    }
  }

  if (notifyTrigger) {
    notifyTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      notifyOpen(this, false);
    });
  }

  section.querySelectorAll('.notify-link, .preorder-notify-trigger').forEach(link => {
    link.addEventListener('click', function (e) {
      e.stopPropagation();
      /* These triggers sit away from the morph (a variant tile, the pre-order
         line, the sticky bar), so bring it into view before expanding. */
      notifyOpen(this, true);
    });
  });

  if (notifyMorph) {
    notifyMorph.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.stopPropagation();
        notifyCollapse(true);
      }
    });
    bindDocListener('click', 'notify-outside', function (e) {
      if (notifyState() !== 'open') return;
      if (notifyMorph.contains(e.target)) return;
      /* A half-typed address is work the customer has already done. A stray tap
         must not throw it away — Escape still closes, deliberately. */
      if (notifyEmailInput && notifyEmailInput.value.trim()) return;
      notifyCollapse(false);
    });
  }

  if (notifyForm) {
    /* JS owns validation from here so the shopper gets an inline line instead
       of a browser bubble. `required` and type=email stay on the field, so a
       no-JS render still validates natively. */
    notifyForm.setAttribute('novalidate', '');

    /* The send never travels as a real submit event. Shopify's challenge
       script listens for submit on customer forms and can re-fire the form
       natively, unloading the page mid-morph, and listener order between us
       and it is not ours to control. So the button is type=button, Enter is
       handled by hand, and this submit listener stays only as a safety net
       for any path that still manages to raise the event. */
    notifyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      notifySend();
    });
    const notifySendBtn = notifyForm.querySelector('.notify-morph__send');
    if (notifySendBtn) {
      /* Downgraded from submit here, not in the Liquid, so a no-JS render
         keeps a working native submit. */
      notifySendBtn.setAttribute('type', 'button');
      notifySendBtn.addEventListener('click', function () { notifySend(); });
    }
    if (notifyEmailInput) notifyEmailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); notifySend(); }
    });

    function notifySend() {
      if (notifyState() === 'sending') return;

      const notifyEmail = notifyEmailInput ? notifyEmailInput.value.trim() : '';
      if (!notifyEmail || (notifyEmailInput.checkValidity && !notifyEmailInput.checkValidity())) {
        notifyMessage(notifyStrings.invalid || 'Please check the email address.');
        if (notifyEmailInput) {
          notifyEmailInput.setAttribute('aria-invalid', 'true');
          notifyEmailInput.focus();
        }
        return;
      }
      if (notifyEmailInput) notifyEmailInput.removeAttribute('aria-invalid');
      notifyMessage('');
      notifySetState('sending');

      /* Klaviyo back-in-stock subscription — the wire that makes the
         `Subscribed to Back in Stock` trigger (SS · Back in Stock flow)
         actually fire. Fire-and-forget: the Shopify contact capture below
         stays the fallback record either way. The $shopify variant namespace
         is served by the Klaviyo Shopify integration (verified live 07-16;
         it works even though the catalog API only lists $custom items). Also
         identify the browser so browse-abandonment reaches this email.
         Deliberately NOT behind the marketing-consent gate: typing an email
         into "notify me when it's back" is an explicit request for exactly
         this message (transactional basis); the flow's entry filter applies
         the marketing-consent policy at send time (see the flow spec).
         keepalive so the challenge-path native form submit below cannot
         abort it mid-flight. */
      let klaviyoResult = Promise.resolve(false);
      if (notifyEmail && notifyVariantId) {
        klaviyoResult = fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VFiMuh', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: { data: { type: 'profile', attributes: { email: notifyEmail.toLowerCase() } } }
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + notifyVariantId } }
              }
            }
          })
        }).then(resp => {
          if (!resp.ok) console.warn('Klaviyo back-in-stock subscribe failed', resp.status);
          return resp.ok;
        }).catch(err => { console.warn('Klaviyo back-in-stock subscribe error', err); return false; });
      }
      if (notifyEmail && window.SSKlv) window.SSKlv.identify(notifyEmail);

      /* Persistence: POST the real Liquid-rendered form (it carries form_type,
         utf8 and the authenticity_token Shopify requires; a hand-built body
         without the token is rejected and captures nothing). This on-page POST
         is the path already running in production — unchanged here, only the
         surface around it moved.
         Two failure paths, deliberately different:
           - Shopify answers but wants a captcha challenge (or errors): fall
             back to a native submit so the shopper can pass the challenge and
             the email still lands. Navigation is the price of a real capture.
           - The request never lands at all (offline, blocked): stay put and
             say so inline. A native submit here would only fail again, louder. */
      fetch(notifyForm.action || '/contact', {
        method: 'POST',
        body: new URLSearchParams(new FormData(notifyForm))
      }).then((resp) => {
        if (resp.ok && resp.url.indexOf('/challenge') === -1) {
          notifyShowDone();
        } else {
          /* This store runs Shopify's form captcha, so a scripted POST to
             /contact is answered with a challenge EVERY time, not just for
             suspicious traffic. The old fallback here was notifyForm.submit(),
             which unloaded the page on every single send — the exact thing the
             morph exists to stop. The notification itself runs on the Klaviyo
             back-in-stock subscription above, which the captcha never touches,
             so when Shopify wants a challenge we let the duplicate contact-tag
             record go rather than the page. Klaviyo's own result decides
             between the quiet confirmation and the inline retry. */
          klaviyoResult.then((klaviyoOk) => {
            if (klaviyoOk) {
              notifyShowDone();
            } else {
              notifySetState('open');
              notifyMessage(notifyStrings.failed || 'That didn\'t send. Try again.');
              if (notifyEmailInput) notifyEmailInput.focus();
            }
          });
        }
      }).catch(() => {
        /* /contact never landed (offline, blocked). Klaviyo may still have
           made it — same decision as the challenge path. */
        klaviyoResult.then((klaviyoOk) => {
          if (klaviyoOk) {
            notifyShowDone();
          } else {
            notifySetState('open');
            notifyMessage(notifyStrings.failed || 'That didn\'t send. Try again.');
            if (notifyEmailInput) notifyEmailInput.focus();
          }
        });
      });
    }
  }

  function notifyShowDone() {
    notifySetState('done');
    notifyMessage(notifyStrings.done || '', true);
    if (notifyForm) notifyForm.reset();
    /* The confirmation is the resting state now. It stands for this variant
       until the shopper picks a different sold-out one (notifyApplyContext
       re-arms) or the page reloads. No timer: an auto-revert to "Notify me"
       reads as the subscription being undone. */
    notifySubscribedVariantId = notifyVariantId || notifySubscribedVariantId;
  }

  // ============================================
  // BURN TIMELINE — disclosure
  //
  // Same primitive as the round-1 disclosures: a grid whose second row goes
  // 0fr -> 1fr, so it opens to the panel's real height. The tier stagger is
  // pure CSS off --tier-i; nothing here needs to know how many tiers rendered.
  // ============================================
  const pdpTimeline = section.querySelector('[data-pdp-timeline]');
  if (pdpTimeline) {
    const timelineHead = pdpTimeline.querySelector('.pdp-timeline__head');
    if (timelineHead) {
      timelineHead.addEventListener('click', function () {
        const isOpen = pdpTimeline.classList.toggle('is-open');
        timelineHead.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  }

  /* The form switcher's sliding-indicator JS lived here until 2026-08-06,
     when the switcher row was reduced to one quiet "also as" line that needs
     no script at all (snippets/pdp-form-switcher.liquid). */

  // ============================================
  // PDP INFO LAYOUT — TABS (desktop option)
  //
  // SELF-CONTAINED ON PURPOSE. Everything this feature needs is in this one
  // function plus the .pdp-tabs block in product-hero.css and the
  // `info_layout` select in the section schema. Lift those three and the
  // behaviour comes with them into a rebuilt hero.
  //
  // Rules it holds to:
  //   - The section setting must say "tabs" AND the viewport must be >=990px.
  //     Below that, or on the default setting, the accordions render and
  //     behave exactly as they always have. The mobile experience does not
  //     change, at all.
  //   - It never rewrites content. Each .accordion keeps its markup, its
  //     data-translate-key hooks and its inner HTML; the header is hidden by
  //     CSS and the accordion itself becomes the panel.
  //   - Teardown puts every node back in its original order, so crossing the
  //     990px line in either direction leaves a clean DOM.
  //   - WAI-ARIA tabs pattern with automatic activation: arrows move and
  //     activate, Home/End jump to the ends, roving tabindex keeps one tab
  //     stop for the whole row.
  // ============================================
  (function pdpInfoTabs() {
    const stack = document.getElementById('accordionSection-' + sectionId);
    if (!stack || stack.getAttribute('data-info-layout') !== 'tabs') return;

    const accordions = Array.prototype.slice.call(stack.querySelectorAll('.accordion'));
    /* One panel is not a tab row. */
    if (accordions.length < 2) return;
    if (!window.matchMedia) return;

    const tabsMq = window.matchMedia('(min-width: 990px)');
    const tabsReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    let tabsBuilt = false;
    let tabsList = null;
    let tabsIndicator = null;
    let tabsPanels = null;
    let tabsHeightObserver = null;
    const tabButtons = [];
    let tabsActive = 0;

    function tabsSyncHeight() {
      if (!tabsPanels) return;
      const panel = accordions[tabsActive];
      if (!panel) return;
      tabsPanels.style.height = panel.offsetHeight + 'px';
    }

    function tabsMoveIndicator() {
      if (!tabsIndicator || !tabsList) return;
      const btn = tabButtons[tabsActive];
      if (!btn) return;
      const listRect = tabsList.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      if (!btnRect.width) return;
      tabsIndicator.style.width = btnRect.width + 'px';
      tabsIndicator.style.transform = 'translateX(' + (btnRect.left - listRect.left) + 'px)';
    }

    function tabsActivate(index, focusTab) {
      if (index < 0 || index >= tabButtons.length) return;
      tabsActive = index;
      tabButtons.forEach(function (btn, i) {
        const on = i === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.setAttribute('tabindex', on ? '0' : '-1');
        /* .active is the accordion's own open class. Reusing it means the
           panel is open by the same rule in both layouts, and teardown leaves
           the stack in a state the accordion handler already understands. */
        accordions[i].classList.toggle('active', on);
        accordions[i].classList.toggle('is-tab-active', on);
      });
      tabsMoveIndicator();
      tabsSyncHeight();
      if (tabsHeightObserver) {
        tabsHeightObserver.disconnect();
        tabsHeightObserver.observe(accordions[index]);
      }
      if (focusTab) tabButtons[index].focus();
    }

    function tabsKeydown(e) {
      const last = tabButtons.length - 1;
      let next = null;
      if (e.key === 'ArrowRight') next = tabsActive === last ? 0 : tabsActive + 1;
      else if (e.key === 'ArrowLeft') next = tabsActive === 0 ? last : tabsActive - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      if (next === null) return;
      e.preventDefault();
      tabsActivate(next, true);
    }

    function tabsBuild() {
      if (tabsBuilt) return;

      tabsList = document.createElement('div');
      tabsList.className = 'pdp-tabs__list';
      tabsList.setAttribute('role', 'tablist');

      tabsPanels = document.createElement('div');
      tabsPanels.className = 'pdp-tabs__panels';

      accordions.forEach(function (acc, i) {
        const titleEl = acc.querySelector('.accordion-title');
        const panel = acc.querySelector('.accordion-content');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-tabs__tab';
        btn.setAttribute('role', 'tab');
        btn.id = 'pdpTab-' + sectionId + '-' + i;
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
        btn.textContent = titleEl ? titleEl.textContent.trim() : '';

        if (panel) {
          if (!panel.id) panel.id = 'pdpTabPanel-' + sectionId + '-' + i;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', btn.id);
          /* A tabpanel holds no focusable content of its own here, and a
             keyboard user still has to be able to scroll it. tabindex 0 is
             what the WAI-ARIA pattern asks for in that case. */
          panel.setAttribute('tabindex', '0');
          btn.setAttribute('aria-controls', panel.id);
        }

        btn.addEventListener('click', function () { tabsActivate(i, false); });
        btn.addEventListener('keydown', tabsKeydown);

        tabButtons.push(btn);
        tabsList.appendChild(btn);
        tabsPanels.appendChild(acc);
      });

      tabsIndicator = document.createElement('span');
      tabsIndicator.className = 'pdp-tabs__indicator';
      tabsIndicator.setAttribute('aria-hidden', 'true');
      tabsList.appendChild(tabsIndicator);

      stack.appendChild(tabsList);
      stack.appendChild(tabsPanels);
      stack.classList.add('is-tabs');

      /* A tabpanel's height is the only thing that can move the page here, so
         it is watched rather than measured once: a webfont landing or a
         translation swap changes it after first paint. */
      if ('ResizeObserver' in window) {
        tabsHeightObserver = new ResizeObserver(function () { tabsSyncHeight(); });
      }

      tabsBuilt = true;
      tabsActivate(0, false);
      window.requestAnimationFrame(function () {
        tabsMoveIndicator();
        tabsSyncHeight();
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          tabsMoveIndicator();
          tabsSyncHeight();
        }).catch(function () {});
      }
    }

    function tabsTeardown() {
      if (!tabsBuilt) return;
      if (tabsHeightObserver) {
        tabsHeightObserver.disconnect();
        tabsHeightObserver = null;
      }
      accordions.forEach(function (acc) {
        const panel = acc.querySelector('.accordion-content');
        if (panel) {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
        acc.classList.remove('is-tab-active');
        /* Back to the accordion default: closed, exactly as a fresh render. */
        acc.classList.remove('active');
        const icon = acc.querySelector('.accordion-header .accordion-icon');
        if (icon) icon.textContent = '+';
        /* Appended in the original order, so the stack reads the same as a
           server render once the wrappers are removed below. */
        stack.appendChild(acc);
      });
      if (tabsList && tabsList.parentNode) tabsList.parentNode.removeChild(tabsList);
      if (tabsPanels && tabsPanels.parentNode) tabsPanels.parentNode.removeChild(tabsPanels);
      stack.classList.remove('is-tabs');
      tabsList = null;
      tabsPanels = null;
      tabsIndicator = null;
      tabButtons.length = 0;
      tabsActive = 0;
      tabsBuilt = false;
    }

    function tabsApply() {
      if (tabsMq.matches) tabsBuild();
      else tabsTeardown();
    }

    tabsApply();
    if (tabsMq.addEventListener) tabsMq.addEventListener('change', tabsApply);
    else if (tabsMq.addListener) tabsMq.addListener(tabsApply);

    let tabsResizeTimer = null;
    window.addEventListener('resize', function () {
      if (!tabsBuilt) return;
      window.clearTimeout(tabsResizeTimer);
      tabsResizeTimer = window.setTimeout(function () {
        tabsMoveIndicator();
        tabsSyncHeight();
      }, 120);
    });

    /* Reduced motion is handled in CSS (the crossfade and the height
       transition both drop out). Read here only so a future change cannot
       forget it exists. */
    void tabsReduce;
  })();

  // ============================================
  // DESKTOP COLLAPSING BUY BAR (>=990px)
  //
  // Appears once the buy panel has left the top of the viewport, goes away
  // when it comes back. It owns no form: the button submits the real product
  // form, so the round-1 add-to-cart morph, the drawer and the analytics all
  // run on the path they already do.
  // ============================================
  (function pdpBuyBar() {
    const bar = document.getElementById('pdpBuyBar-' + sectionId);
    if (!bar) return;

    const barCta = document.getElementById('pdpBuyBarCta-' + sectionId);
    if (barCta && productForm) {
      barCta.addEventListener('click', function () {
        /* Claim the add before submitting, so a failure knows to come back
           here rather than only to the form four screens up. */
        atcSubmitOrigin = 'buybar';
        if (productForm.requestSubmit) productForm.requestSubmit();
        else productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    /* The bar's price mirrors the CTA price rather than recomputing it, so
       there is exactly one place in this file that knows how a variant price
       is formatted. Variant switches, multipack tiers and subscription
       discounts all reach the bar for free. */
    const barPriceSrc = document.getElementById('ctaPrice-' + sectionId);
    const barPriceDst = document.getElementById('pdpBuyBarPrice-' + sectionId);
    if (barPriceSrc && barPriceDst && 'MutationObserver' in window) {
      const priceObserver = new MutationObserver(function () {
        barPriceDst.textContent = barPriceSrc.textContent;
      });
      priceObserver.observe(barPriceSrc, { childList: true, characterData: true, subtree: true });
    }

    const barAnchor = productForm
      || section.querySelector('.sold-out-card')
      || section.querySelector('.price-section');
    if (!barAnchor || !('IntersectionObserver' in window) || !window.matchMedia) return;

    const barMq = window.matchMedia('(min-width: 990px)');
    let barObserver = null;

    function barShow(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function barArm() {
      if (barObserver) return;
      barObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /* isIntersecting alone is not enough: it is false both when the
             panel is still below the fold and when it has scrolled above.
             The bar must only appear in the second case, or it would greet
             someone who deep-linked to the reviews before ever seeing the
             buy panel — and it would flash on load. */
          const topEdge = entry.rootBounds ? entry.rootBounds.top : 0;
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= topEdge + 1;
          barShow(scrolledPast);
        });
      }, { threshold: 0 });
      barObserver.observe(barAnchor);
    }

    function barDisarm() {
      if (barObserver) {
        barObserver.disconnect();
        barObserver = null;
      }
      barShow(false);
    }

    function barApply() {
      if (barMq.matches) barArm();
      else barDisarm();
    }

    barApply();
    if (barMq.addEventListener) barMq.addEventListener('change', barApply);
    else if (barMq.addListener) barMq.addListener(barApply);
  })();

  // ============================================
  // INIT
  // ============================================
  updatePricing();
  updateStockDisplay();
})();
